module.exports = __webpack_public_path__ + "img/horizontal_5_1_5012.8d17aa59.png";